exports.install = function(Vue, qq) {
  Vue.prototype.qq = function() {
    if (typeof BizQQWPA != 'undefined')
      BizQQWPA.addCustom([
        {
          aty: '0',
          a: '0',
          nameAccount: qq,
          selector: 'w-online-qq',
        },
        {
          aty: '0',
          a: '0',
          nameAccount: qq,
          selector: 'w-online-qq2',
        },
      ])
  }
}



// WEBPACK FOOTER //
// ./src/utils/plugin.js